import React, { useEffect, useRef, useState } from "react";
import { ChevronDown, FileText, Printer } from "lucide-react";
import "./documentButton.css";

const FORMATS = [["pdf", "PDF"], ["docx", "Word"]];

export const DocumentButton = ({ label, onGenerate, testId, icon = null, disabled = false, formats = FORMATS }) => {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState("");
  const box = useRef(null);

  useEffect(() => {
    if (!open) return;
    const close = event => { if (!box.current?.contains(event.target)) setOpen(false); };
    document.addEventListener("mousedown", close);
    return () => document.removeEventListener("mousedown", close);
  }, [open]);

  async function pick(fmt) {
    setOpen(false); setBusy(fmt);
    try { await onGenerate(fmt); } finally { setBusy(""); }
  }

  return <div className="doc-button" ref={box}>
    <button type="button" className="doc-button-main" data-testid={testId} disabled={disabled || !!busy} onClick={() => setOpen(v => !v)}>
      {icon || <Printer size={15} />}
      <span>{busy ? "Generazione…" : label}</span>
      <ChevronDown size={14} className={open ? "doc-caret open" : "doc-caret"} />
    </button>
    {open && <div className="doc-menu" role="menu" data-testid={`${testId}-menu`}>
      {formats.map(([value, text]) => <button type="button" key={value} role="menuitem" data-testid={`${testId}-${value}`} onClick={() => pick(value)}>
        <FileText size={14} />{text}
      </button>)}
    </div>}
  </div>;
};
